angular.module('tgaAdmin').controller('SSOProviderController', [
  '$scope',
  '$state',
  '$timeout',
  'userService',
  'flashService',
  'modalService',
  'SSOProviderService',
  '$translate',
  function ($scope, $state, $timeout, userService, flashService, modalService, SSOProviderService, $translate) {
    $scope.showBack = true;

    $scope.data = {
      alerts: [],
      SSOProviderId: $state.params.id || null,
    };

    $scope.viewmodel = {
      name: null,
      entity_id: null,
      certificate: null,
      login_url: null,
      metadata_url: null,
      sp_assertion_url: null,
      sp_entity_id: null,
      default_timeout: null,
    };

    $scope.initialize = function () {
      if ($scope.data.SSOProviderId) {
        SSOProviderService.getSSOProvider($scope.data.SSOProviderId).then((SSOProvider) => {
          $scope.viewmodel = SSOProvider;
          $scope.title = `<span class="text-muted">Edit SSO Provider /</span> ${$scope.viewmodel.name}`;
        });
      }
    };

    $scope.actions = {
      deleteSSOProvider() {
        modalService
          .showModal(
            {
              title: 'Delete SSO Provider?',
              message: 'Are you sure you want to delete this SSO provider?',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              $scope.deleting = true;

              SSOProviderService.deleteSSOProvider($scope.viewmodel).then(
                () => {
                  flashService.set('<span class="fa fa-check"></span> SSO provider deleted.', 'success');
                  $state.go('v1.ssoProviders');
                },
                (error) => {
                  $scope.actions.createAlert(
                    `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                    'danger',
                  );
                  $scope.deleting = false;
                },
              );
            },
            () => {},
          );
      },
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;

        if ($scope.data.SSOProviderId) {
          SSOProviderService.updateSSOProvider($scope.viewmodel).then(
            (response) => {
              $scope.actions.createAlert('<span class="fa fa-check"></span> SSO provider updated.', 'success');
              $scope.viewmodel = response;
              $scope.title = `<span class="text-muted">Edit SSO Provider /</span> ${$scope.viewmodel.name}`;
              $scope.processing = false;
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        } else {
          SSOProviderService.addSSOProvider($scope.viewmodel).then(
            (response) => {
              flashService.set('<span class="fa fa-check"></span> SSO provider added.', 'success');
              $state.go('v1.editSSOProvider', { id: response.sso_provider_id });
              $scope.processing = false;
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        }
      },
      copySuccess(name) {
        if ($scope.copyTimer) {
          $timeout.cancel($scope.copyTimer);
        }

        $scope.data.copied = name;

        $scope.copyTimer = $timeout(() => {
          $scope.data.copied = false;
        }, 1500);
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
